var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
var FAQSection = function FAQSection(_ref) {
  var data = _ref.data;
  var lang = useLang();
  var _useState = useState(0),
    activeFaqIndex = _useState[0],
    setActiveFaqIndex = _useState[1];
  var _useState2 = useState(false),
    showAllFaqs = _useState2[0],
    setShowAllFaqs = _useState2[1];
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var toggleFaq = function toggleFaq(index) {
    setActiveFaqIndex(activeFaqIndex === index ? -1 : index);
  };
  var toggleShowMore = function toggleShowMore() {
    setShowAllFaqs(!showAllFaqs);
    setActiveFaqIndex(-1);
  };
  var faqs = data === null || data === void 0 ? void 0 : data.faq_items;
  var title = data === null || data === void 0 ? void 0 : data.tilte;
  var subtitle = data === null || data === void 0 ? void 0 : data.subtitle;

  // Determine which FAQs to display
  var displayedFaqs = showAllFaqs ? faqs : faqs.slice(0, 4);
  return /*#__PURE__*/React.createElement("section", {
    id: "faq-section",
    className: "my-4 md:my-10 px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "faq-container",
    className: "mx-auto md:max-w-[1200px]"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "faq-title",
    className: "text-[20px] font-bold text-primary-new text-center mb-2 md:mb-5 md:text-[40px]"
  }, title), /*#__PURE__*/React.createElement("p", {
    id: "faq-subtitle",
    className: "text-[14px] font-medium text-[#020202] text-center mb-10 md:mb-8 md:text-[20px] leading-10"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    id: "faq-items-container",
    className: "space-y-4"
  }, displayedFaqs.map(function (faq, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "faq-item-".concat(index),
      className: "border-[1px] border-solid border-[#D6DFE9] rounded-lg overflow-hidden",
      key: index,
      onClick: function onClick() {
        return toggleFaq(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "faq-item-header-".concat(index),
      className: "flex justify-between ".concat(activeFaqIndex === index ? 'items-start' : 'items-center', " gap-2 p-5 sm:p-4 cursor-pointer transition-all duration-300 ease-in-out")
    }, /*#__PURE__*/React.createElement("span", {
      id: "faq-item-question-".concat(index),
      className: "text-4 sm:text-3 sm:line-height-6 font-bold text-primary-new text-right rtl:text-right ltr:text-left"
    }, faq.question), /*#__PURE__*/React.createElement("span", {
      id: "faq-item-toggle-icon-".concat(index),
      className: "flex items-center justify-center text-primary-new shrink-0 w-6 h-6"
    }, activeFaqIndex === index ? /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-up-rounded"
    }) : /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-down-rounded"
    }))), activeFaqIndex === index && /*#__PURE__*/React.createElement("div", {
      id: "faq-item-answer-".concat(index),
      className: "p-[0_20px_20px] text-4 sm:text-3 sm:line-height-4 leading-[1.6] text-[#6B7EA5] text-right rtl:text-right ltr:text-left"
    }, faq.answer));
  })), faqs.length > 4 && /*#__PURE__*/React.createElement("button", {
    id: "faq-show-more-button",
    onClick: toggleShowMore,
    className: "items-center block mx-auto mt-[30px] py-3 px-[30px] bg-primary-new text-white border-none rounded-[6px] text-[16px] font-semibold cursor-pointer transition-all duration-300 ease-in-out hover:bg-primary-new hover:translate-y-[-2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)]"
  }, showAllFaqs ? tShort('faq/show_less_button', {
    ns: 'web_sell_trade'
  }) : tShort('faq/show_more_button', {
    ns: 'web_sell_trade'
  }))));
};
export default FAQSection;